import React from "react";
import { Text, Flex, Box } from "theme-ui";
import { Col } from "antd";

class StatusBox extends React.PureComponent {

    render() {
        const { className, blockName, value, maxValue } = this.props;
        return (
                <Flex p={2} className={className} sx={{
                    height: "40px",
                    backgroundColor: "white",
                    alignItems: "center",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderRadius: "4px"

                }}>
                    <div className="contrib-stat" />
                    <Text sx={{
                        fontSize: "14px",
                        lineHeight: "24px",
                        ml: "16px"
                    }}>
                        {blockName}
                    </Text>
                    <Box ml="auto">
                        {value} / {maxValue}
                    </Box>
                </Flex>
        );
    }
}

export default StatusBox;
